/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import ImageItem from './ImageItem/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Gallery/Content/PatientImages/AllImages/PatientImage/Content"
  
}) {
let patientImageIdValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'id',
})
let galleryImageIdValueData = fromData.useDataValue({ viewPath,
context: 'gallery',
path: 'image_id',
})
let aggregateData = fromAggregate.equals(patientImageIdValueData, galleryImageIdValueData)
  return (<React.Fragment
>
<ImageItem
  viewPath={`${viewPath}/ImageItem`}
 data="patient_image.id"
 data="gallery.image_id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
/>
{children}
</React.Fragment>)
}